import { InvoicesSummaryAction } from './actions';

import {
  INVOICES_SUMMARY_REQUEST_START,
  INVOICES_SUMMARY_REQUEST_FAIL,
  INVOICES_SUMMARY_REQUEST_SUCCESS,
  ANNUAL_STATEMENT_DOWNLOAD_REQUEST_START,
  ANNUAL_STATEMENT_DOWNLOAD_REQUEST_SUCCESS,
  ANNUAL_STATEMENT_DOWNLOAD_REQUEST_FAIL,
  ANNUAL_STATEMENT_DOWNLOAD_REQUEST_RESET,
} from './types';

export interface FileListType {
  fileByte: string,
  fileName: string
}

type InvoicesSummaryState = {
  loadingState: string,
  annualStatementDownloadLoading: string,
  results: any,
  fileList: FileListType[] | null;
};

export const INITIAL_STATE: InvoicesSummaryState = {
  loadingState: 'UNINITIALISED',
  annualStatementDownloadLoading: 'UNINITIALISED',
  fileList: null,
  results: {
    table: []
  }
};

export const reducer = (
  state = INITIAL_STATE,
  action: InvoicesSummaryAction
): InvoicesSummaryState => {
  switch (action.type) {
    case INVOICES_SUMMARY_REQUEST_START:
      return {
        ...state,
        loadingState: 'LOADING',
      };

    case INVOICES_SUMMARY_REQUEST_SUCCESS:
      return {
        ...state,
        loadingState: 'LOADED',
        results: action.payload
      };

    case INVOICES_SUMMARY_REQUEST_FAIL:
      return {
        ...state,
        loadingState: 'ERROR',
      };
    case ANNUAL_STATEMENT_DOWNLOAD_REQUEST_START:
      return {
        ...state,
        annualStatementDownloadLoading: 'LOADING',
      };

    case ANNUAL_STATEMENT_DOWNLOAD_REQUEST_SUCCESS:
      return {
        ...state,
        annualStatementDownloadLoading: 'LOADED',
        fileList: action.payload.fileList
      };

    case ANNUAL_STATEMENT_DOWNLOAD_REQUEST_FAIL:
      return {
        ...state,
        annualStatementDownloadLoading: 'ERROR',
      };
    case ANNUAL_STATEMENT_DOWNLOAD_REQUEST_RESET:
      return {
        ...state,
        annualStatementDownloadLoading: 'UNINITIALISED',
        fileList: null
      };

    default:
      return state;
  }
};